import { Suspense } from 'react';
import { Loader } from '@givebutter/primitives/loader';
import { PersonalizedLetterCurrentContactHeader } from 'assets/js/pages/engage/letters/PersonalizedLetterCurrentContactHeader';
import { PersonalizedLetterWysiwyg } from 'assets/js/pages/engage/letters/PersonalizedLetterWysiwyg';
import { usePersonalizedLettersStore } from 'assets/js/pages/engage/letters/usePersonalizedLettersStore';

const PersonalizedLetterCompose = () => {
    const { currentPersonalizedLetterContact } = usePersonalizedLettersStore();

    return (
        <Suspense fallback={<Loader />}>
            <div className={'flex flex-col gap-8'}>
                {currentPersonalizedLetterContact ? (
                    <>
                        <PersonalizedLetterCurrentContactHeader />
                        <div className={'px-6'}>
                            <PersonalizedLetterWysiwyg />
                        </div>
                    </>
                ) : (
                    <NoContactSelected />
                )}
            </div>
        </Suspense>
    );
};
const NoContactSelected = () => (
    <div className={'flex items-center justify-center p-8'}>
        <p className={'text-xl font-medium'}>Please select a contact</p>
    </div>
);

export { PersonalizedLetterCompose };
